import { OrderStatus } from '@/core/models/order.model'
import { useGetMeetingLinkOrdersQuery } from '@/core/services/order'
import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'

export function usePendingOrdersBadge(): number {
  const authUser = useAppSelector(selectAuthUser)
  const { data: pendingOrders } = useGetMeetingLinkOrdersQuery(
    { acceptedBy: authUser?._id, status: [OrderStatus.Pending] },
    { skip: !authUser, pollingInterval: 30000 }
  )

  return pendingOrders?.length ?? 0
}
